export function getFromPath(initValue: any, path: string[]) {
    return path.reduce((prev, curr) => prev?.[curr], initValue);
}

// export function setToPath(obj: any, path: string[], value: any) {
//     const last = path.pop()!;
//     const parent = path.reduce((prev, curr) => {
//         if (!(curr in prev)) prev[curr] = {};

//         return prev[curr];
//     }, obj);

//     parent[last] = value;
// }
export function setToPath(obj: any, path: readonly string[], value: any) {
    const last = path[path.length - 1];

    const parent = path.slice(0, -1).reduce((prev, curr) => {
        if (!(curr in prev)) prev[curr] = {};
        return prev[curr];
    }, obj);

    parent[last] = value;
}